function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'0a840ef45467fb3932dbf2c2896c5cbf': 'rgb(112, 109, 107)','06a311b9097555ff46e11ef76b194f6e': 'rgb(116, 101, 72)','f3311d3d14c8437553bf3e3f90920736': 'rgb(53, 63, 100)',};

    this.images = {'42133a3dcbeafd8d1b0a68cae646de2a': 'url("//www.hardmill.com/cdn/shop/files/Charcoal_68x.png?v=9253120431258150633")','4aaff186620a62daab5ffdcf30a19b36': 'url("//www.hardmill.com/cdn/shop/files/Dark_Oak_68x.png?v=11902111418991560983")','243df6bd1906df423cff6beea34331fe': 'url("//www.hardmill.com/cdn/shop/files/Field_Tan_68x.png?v=11702018658247083012")','5b2d4484498235e80d61a233a7c04991': 'url("//www.hardmill.com/cdn/shop/files/Field_Tan_68x.png?v=11702018658247083012")','f431b0eea3c08186ed101e588bfb3a2f': 'url("//www.hardmill.com/cdn/shop/files/Olive_68x.png?v=11008392387891666909")','1bd5f8462cb48e189100fc90bb2e82db': 'url("//www.hardmill.com/cdn/shop/files/Indigo_Waxed_Denim_68x.png?v=10449872811786086642")','25c5ac514056c90f1db1313ba6b2244b': 'url("//www.hardmill.com/cdn/shop/files/Indigo_Waxed_Denim_68x.png?v=10449872811786086642")','06017ad87530136e539ca9b4c9a1a893': 'url("//www.hardmill.com/cdn/shop/files/Black_Waxed_Denim_68x.png?v=4058771564111538907")','db42aa2eb596efa814cf0eaceb5fec73': 'url("//www.hardmill.com/cdn/shop/files/Black_Waxed_Denim_68x.png?v=4058771564111538907")','9ad690722666019935864defc71d4fa7': 'url("//www.hardmill.com/cdn/shop/files/Cognac_Leather_68x.png?v=16850557075668213055")','67c383a93f81a863bbfce97b3bd16cab': 'url("//www.hardmill.com/cdn/shop/files/Cognac_Leather_68x.png?v=16850557075668213055")','6ff47afa5dc7daa42cc705a03fca8a9b': 'url("//www.hardmill.com/cdn/shop/files/Cognac_Leather_68x.png?v=16850557075668213055")','1ffd9e753c8054cc61456ac7fac1ac89': 'url("//www.hardmill.com/cdn/shop/files/Black_68x.png?v=8127890977064709834")','5abea42e4c9ad59c9d5abaad50fc1e07': 'url("//www.hardmill.com/cdn/shop/files/Black_68x.png?v=8127890977064709834")',};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) swatch.style.setProperty('--tick-color', '#000');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
